export default __webpack_public_path__ + "static/media/large-frame-bg1.9352bb14.svg";